'use strict';

Object.defineProperty(exports, "__esModule", { value: true });
exports.Maintenance = void 0;
var transport_1 = require("../../transport");
var Maintenance = /** @class */ (function () {
    function Maintenance() {
    }
    Maintenance.prototype.filter = function () {
        return transport_1.transport.request('maintenance/filter');
    };
    return Maintenance;
}());
exports.Maintenance = Maintenance;
